import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const scholineApi = createApi({
  reducerPath: "scholineApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://www.scholine.com",
  }),
  endpoints(builder) {
    return {
      createRegistration: builder.mutation({
        query: ({ firstName, lastName, school, phone, email }) => {
          return {
            url: "/api/scholine/registration",
            method: "POST",
            body: {
              firstName,
              lastName,
              school,
              phone,
              email,
            },
          };
        },
      }),

      submitResume: builder.mutation({
        query: (formData) => ({
          url: "/api/scholine/resume",
          method: "POST",
          body: formData, 
        }),
      }),
    };
  },
});


export const { 
useCreateRegistrationMutation,
useSubmitResumeMutation, 
} = scholineApi;
export { scholineApi };
